<template>
  <div>
    <ArticleRegist></ArticleRegist>
  </div>
</template>

<script>
import ArticleRegist from "@/components/article/ArticleRegist.vue";

export default {
  name: "ArticleRegistView",
  components: {
    ArticleRegist
  }
};
</script>

<style></style>
